// @flow
import { NOTIFICATION_TYPE } from './constants'
import { withPropsOnChange } from 'recompose'
import { StatusTypes } from '../../ui/notifications/notification'
import { NOTIFICATION_HIDE_DELAY } from '../../config/index'
import type { Notification } from './types'

// these come from Provider
type ConnectProps = {
  notification: ?Notification,
  dismissNotification: (id: string) => Promise<boolean>
}

export type NotificationProps = {
  title: ?string,
  text: ?string,
  status: string,
  iconName: ?string,
  // for redirecting when notification is clicked
  url: ?string,
  hideDelay: ?number
}
export default withPropsOnChange(['notification'], (props: ConnectProps) => {
  if (!props.notification) return {}
  const notification: Notification = props.notification

  // create Notification UI props for each type of notification we attend
  switch (notification.type) {
    case NOTIFICATION_TYPE.BID_WINNING:
      return {
        title: `The highest bid for ${notification.name ||
          'the product'} is yours!`,
        text: 'You will be notified if you are outbid',
        iconName: 'notifications',
        hideDelay: NOTIFICATION_HIDE_DELAY,
        status: StatusTypes.SUCCESS
      }
    case NOTIFICATION_TYPE.BID_OUTBID:
      return {
        title: 'You have been outbid!',
        text: `Click to see ${
          notification.name ? notification.name : 'the product'
        }`,
        url: `/items/${String(notification.itemId)}`,
        hideDelay: NOTIFICATION_HIDE_DELAY,
        status: StatusTypes.ERROR
      }
    case NOTIFICATION_TYPE.SAVED_EVENT_START:
      return {
        title: `${notification.name ||
          'One of your saved auctions'} is now open!`,
        text: 'Click to see the auction page',
        url: `/auctions/${String(notification.auctionId)}`,
        status: StatusTypes.INFO
      }
    case NOTIFICATION_TYPE.SAVED_ITEM_START:
      return {
        title: 'Bidding has started for one of your saved items',
        text: `Click to see ${notification.name || 'the product page'}`,
        url: `/items/${String(notification.itemId)}`,
        status: StatusTypes.INFO
      }
    default:
      return {}
  }
})



// WEBPACK FOOTER //
// ./src/services/notification/withNotification.js